export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wczoraj"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzisiaj"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poniedziałek"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wtorek"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Środa"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czwartek"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piątek"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sobota"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niedziela"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stycznia"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["lutego"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["marca"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["kwietnia"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["maja"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["czerwca"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["lipca"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sierpnia"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["września"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["października"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["listopada"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["grudnia"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ty"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator"])}
}